// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__XTuP-","consentsList":"PatientConsents_consentsList__23AWp","consentsListEmpty":"PatientConsents_consentsListEmpty__2Zrc-"};